import gsap from 'gsap';

const extra = document.querySelector('#extra');
const container = document.querySelector('#extra-container');
const extraBtn = document.querySelector('#extra-button');

function toggle() {
  if (extra.classList.contains('extra-is-active')) {
    gsap.to(container, {height: 0, opacity: 0, duration: 0.2});
  } else {
    gsap.set(container, {height: 'auto', opacity: 1});
    gsap.from(container, {height: 0, opacity: 0, duration: 0.2});
  }

  extra.classList.toggle('extra-is-active');
}

function init() {
  if (!extraBtn) {
    return;
  }
  extraBtn.addEventListener('click', toggle);
}

init();
